(function () {
  'use strict';

  var STORAGE_KEY = 'dorie-wishlist';
  var EMAIL_KEY   = 'dorie-wishlist-email';
  var MODAL_SHOWN = 'dorie-wishlist-modal-shown';

  // ─────────────────────────────────────────────
  // LocalStorage manager
  // ─────────────────────────────────────────────
  var WishlistManager = {
    getAll: function () {
      try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}'); }
      catch (e) { return {}; }
    },
    _save: function (items) {
      try { localStorage.setItem(STORAGE_KEY, JSON.stringify(items)); } catch (e) {}
    },
    add: function (product) {
      var items = this.getAll();
      items[String(product.id)] = product;
      this._save(items);
      this._emit();
    },
    remove: function (id) {
      var items = this.getAll();
      delete items[String(id)];
      this._save(items);
      this._emit();
    },
    toggle: function (product) {
      if (this.has(product.id)) { this.remove(product.id); return false; }
      this.add(product); return true;
    },
    has: function (id) { return !!this.getAll()[String(id)]; },
    count: function () { return Object.keys(this.getAll()).length; },
    _emit: function () {
      window.dispatchEvent(new CustomEvent('wishlist:updated', {
        detail: { items: this.getAll(), count: this.count() }
      }));
    }
  };

  // ─────────────────────────────────────────────
  // Klaviyo helpers
  // ─────────────────────────────────────────────
  function klaviyoIdentify(email) {
    if (typeof window.klaviyo === 'undefined') return;
    window.klaviyo.push(['identify', { $email: email }]);
  }

  function klaviyoTrackWishlist(product) {
    if (typeof window.klaviyo === 'undefined') return;
    window.klaviyo.push(['track', 'Added to Wishlist', {
      ProductName:   product.title,
      ProductID:     product.id,
      ProductHandle: product.handle,
      ImageURL:      product.image,
      Price:         (parseInt(product.priceCents, 10) / 100).toFixed(2),
      URL:           window.location.origin + '/products/' + product.handle,
      WishlistCount: WishlistManager.count()
    }]);
  }

  // ─────────────────────────────────────────────
  // Style injection
  // ─────────────────────────────────────────────
  function injectStyles(css, id) {
    if (document.getElementById(id)) return;
    var s = document.createElement('style');
    s.id = id;
    s.textContent = css;
    document.head.appendChild(s);
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  // ─────────────────────────────────────────────
  // Modal config (editable in theme editor)
  // ─────────────────────────────────────────────
  function getModalConfig() {
    try {
      var el = document.getElementById('wishlist-modal-config');
      return el ? JSON.parse(el.textContent) : {};
    } catch (e) { return {}; }
  }

  // ─────────────────────────────────────────────
  // Email capture modal
  // ─────────────────────────────────────────────
  var MODAL_CSS = '#wishlist-email-modal{position:fixed;inset:0;z-index:9999;display:flex;align-items:flex-end;pointer-events:none;opacity:0;transition:opacity .3s ease}'
    + '#wishlist-email-modal.is-open{pointer-events:all;opacity:1}'
    + '.wm-overlay{position:fixed;inset:0;background:rgba(0,0,0,.45)}'
    + '.wm-panel{position:relative;z-index:1;width:100%;background:#fff;padding:32px 24px 44px;transform:translateY(40px);transition:transform .35s cubic-bezier(.32,.72,0,1)}'
    + '#wishlist-email-modal.is-open .wm-panel{transform:translateY(0)}'
    + '.wm-close{position:absolute;top:14px;right:16px;background:none;border:none;font-size:22px;line-height:1;padding:4px 8px;cursor:pointer;color:inherit}'
    + '.wm-heart{color:#b5946a;margin-bottom:12px}'
    + '.wm-title{font-size:.95rem;font-weight:600;letter-spacing:.06em;text-transform:uppercase;margin:0 0 8px}'
    + '.wm-sub{font-size:.8rem;color:rgba(0,0,0,.55);line-height:1.6;margin:0 0 20px}'
    + '.wm-form{display:flex;gap:8px;margin-bottom:12px}'
    + '.wm-input{flex:1;border:1px solid rgba(0,0,0,.2);padding:10px 12px;font-size:.85rem;font-family:inherit;outline:none}'
    + '.wm-input:focus{border-color:rgba(0,0,0,.6)}'
    + '.wm-submit{background:#111;color:#fff;border:none;padding:10px 18px;font-size:.75rem;font-weight:600;letter-spacing:.07em;text-transform:uppercase;cursor:pointer;font-family:inherit;white-space:nowrap}'
    + '.wm-skip{background:none;border:none;color:rgba(0,0,0,.4);font-size:.75rem;cursor:pointer;padding:0;font-family:inherit;text-decoration:underline}'
    + '@media(min-width:750px){#wishlist-email-modal{align-items:center}.wm-panel{width:460px;margin:auto;padding:40px 36px}}';

  function showEmailModal(product) {
    if (localStorage.getItem(EMAIL_KEY)) return;
    if (sessionStorage.getItem(MODAL_SHOWN)) return;
    sessionStorage.setItem(MODAL_SHOWN, '1');
    injectStyles(MODAL_CSS, 'wishlist-modal-css');

    var cfg      = getModalConfig();
    var title    = cfg.title    || 'Save your wishlist';
    var subtitle = cfg.subtitle || 'Enter your email and we\'ll keep your wishlist safe — and let you know if anything goes on sale.';
    var btnText  = cfg.button   || 'Save Wishlist';
    var skipText = cfg.skip     || 'No thanks, continue without saving';

    var modal = document.createElement('div');
    modal.id = 'wishlist-email-modal';
    modal.innerHTML = ''
      + '<div class="wm-overlay"></div>'
      + '<div class="wm-panel">'
      +   '<button class="wm-close" aria-label="Close">&times;</button>'
      +   '<div class="wm-heart"><svg viewBox="0 0 24 24" fill="currentColor" width="26" height="26"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg></div>'
      +   '<p class="wm-title">' + escapeHtml(title) + '</p>'
      +   '<p class="wm-sub">' + escapeHtml(subtitle) + '</p>'
      +   '<form class="wm-form" id="wishlist-capture-form">'
      +     '<input type="email" class="wm-input" placeholder="Your email address" required autocomplete="email">'
      +     '<button type="submit" class="wm-submit">' + escapeHtml(btnText) + '</button>'
      +   '</form>'
      +   '<button class="wm-skip">' + escapeHtml(skipText) + '</button>'
      + '</div>';

    document.body.appendChild(modal);
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { modal.classList.add('is-open'); });
    });

    function closeModal() {
      modal.classList.remove('is-open');
      setTimeout(function () { if (modal.parentNode) modal.parentNode.removeChild(modal); }, 360);
    }

    modal.querySelector('.wm-overlay').addEventListener('click', closeModal);
    modal.querySelector('.wm-close').addEventListener('click', closeModal);
    modal.querySelector('.wm-skip').addEventListener('click', closeModal);
    modal.querySelector('#wishlist-capture-form').addEventListener('submit', function (e) {
      e.preventDefault();
      var email = this.querySelector('input[type="email"]').value.trim();
      if (!email) return;
      localStorage.setItem(EMAIL_KEY, email);
      klaviyoIdentify(email);
      klaviyoTrackWishlist(product);
      closeModal();
    });
  }

  // ─────────────────────────────────────────────
  // Heart buttons on collection product cards
  // ─────────────────────────────────────────────
  var HEART_CSS = ''
    + '.wishlist-heart{position:absolute;top:8px;right:8px;z-index:2;background:rgba(255,255,255,.85);border:none;border-radius:50%;width:28px;height:28px;display:flex;align-items:center;justify-content:center;cursor:pointer;padding:0;transition:transform .2s ease,background .2s ease;backdrop-filter:blur(4px)}'
    + '.wishlist-heart:hover{background:#fff;transform:scale(1.1)}'
    + '.wishlist-heart svg{width:12px;height:12px;stroke:rgba(0,0,0,.45);fill:none;transition:stroke .2s,fill .2s;pointer-events:none}'
    + '.wishlist-heart.is-wishlisted svg{stroke:#b5946a;fill:#b5946a}'
    + '.wishlist-heart:focus-visible{outline:2px solid #111;outline-offset:2px}';

  var HEART_SVG = '<svg viewBox="0 0 24 24"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>';

  function createHeart(card) {
    if (card.querySelector('.wishlist-heart')) return;
    if (card.dataset.placeholder) return;
    var id = card.dataset.productId;
    if (!id) return;

    injectStyles(HEART_CSS, 'wishlist-heart-css');

    var wishlisted = WishlistManager.has(id);
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'wishlist-heart' + (wishlisted ? ' is-wishlisted' : '');
    btn.setAttribute('aria-label', wishlisted ? 'Remove from wishlist' : 'Add to wishlist');
    btn.innerHTML = HEART_SVG;

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      var product = {
        id:                  id,
        handle:              card.dataset.wishlistHandle  || '',
        title:               card.dataset.wishlistTitle   || '',
        priceCents:          card.dataset.wishlistPrice   || '0',
        image:               card.dataset.wishlistImage   || '',
        variantId:           card.dataset.wishlistVariantId || '',
        hasMultipleVariants: card.dataset.wishlistMultiVariants === 'true'
      };

      var added = WishlistManager.toggle(product);
      btn.classList.toggle('is-wishlisted', added);
      btn.setAttribute('aria-label', added ? 'Remove from wishlist' : 'Add to wishlist');

      if (added) {
        klaviyoTrackWishlist(product);
        showEmailModal(product);
      }
    });

    if (getComputedStyle(card).position === 'static') card.style.position = 'relative';
    card.appendChild(btn);
  }

  function initHearts() {
    document.querySelectorAll('product-card[data-product-id]').forEach(createHeart);
  }

  // Watch for AJAX-loaded cards (filters, infinite scroll)
  var cardObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.tagName === 'PRODUCT-CARD' && node.dataset.productId) {
          createHeart(node);
        } else if (node.querySelectorAll) {
          node.querySelectorAll('product-card[data-product-id]').forEach(createHeart);
        }
      });
    });
  });

  // ─────────────────────────────────────────────
  // Badge count on drawer wishlist link
  // ─────────────────────────────────────────────
  function updateBadges() {
    var count = WishlistManager.count();
    document.querySelectorAll('.wishlist-count-badge').forEach(function (badge) {
      badge.textContent = count || '';
      badge.style.display = count > 0 ? 'inline-flex' : 'none';
    });
  }

  window.addEventListener('wishlist:updated', updateBadges);

  // ─────────────────────────────────────────────
  // Money formatter
  // ─────────────────────────────────────────────
  function formatMoney(cents) {
    var amount = parseInt(cents, 10) / 100;
    return window.Shopify && window.Shopify.currency
      ? Shopify.currency.active + ' ' + amount.toFixed(2)
      : '$' + amount.toFixed(2);
  }

  // ─────────────────────────────────────────────
  // Wishlist page — build & render cards from localStorage
  // ─────────────────────────────────────────────
  function buildCard(product) {
    var price = formatMoney(product.priceCents);

    var card = document.createElement('div');
    card.className = 'wishlist-item';
    card.id = 'wishlist-item-' + product.id;
    card.dataset.wishlistProductId = product.id;
    card.dataset.wishlistVariantId = product.variantId || '';

    var imgHtml = product.image
      ? '<a href="/products/' + product.handle + '" class="wishlist-item__img-link"><img src="' + product.image + '" alt="' + escapeHtml(product.title) + '" class="wishlist-item__img" loading="lazy"></a>'
      : '<a href="/products/' + product.handle + '" class="wishlist-item__img-link wishlist-item__img-link--empty"></a>';

    var variantHtml = product.hasMultipleVariants
      ? '<select class="wishlist-item__variant-select" aria-label="Select variant"></select>'
      : '';

    card.innerHTML = imgHtml
      + '<div class="wishlist-item__info">'
      +   '<a href="/products/' + product.handle + '" class="wishlist-item__title">' + escapeHtml(product.title) + '</a>'
      +   '<p class="wishlist-item__price">' + escapeHtml(price) + '</p>'
      +   variantHtml
      +   '<div class="wishlist-item__actions">'
      +     '<button type="button" class="wishlist-item__add-btn">Add to Cart</button>'
      +     '<button type="button" class="wishlist-item__remove" data-wishlist-remove="' + product.id + '">Remove</button>'
      +   '</div>'
      + '</div>';

    return card;
  }

  function refreshCard(card, handle) {
    fetch('/products/' + handle + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (!data) return;

        var priceEl = card.querySelector('.wishlist-item__price');
        if (priceEl && data.price) priceEl.textContent = formatMoney(data.price);

        var sel = card.querySelector('.wishlist-item__variant-select');
        if (data.variants && data.variants.length > 1) {
          if (sel) {
            sel.innerHTML = data.variants.map(function (v) {
              return '<option value="' + v.id + '"' + (v.available ? '' : ' disabled') + '>'
                + escapeHtml(v.title) + (v.available ? '' : ' — Sold out') + '</option>';
            }).join('');
            sel.style.display = 'block';
            var first = data.variants.find(function (v) { return v.available; });
            if (first) card.dataset.wishlistVariantId = String(first.id);
          }
        } else if (data.variants && data.variants.length === 1) {
          card.dataset.wishlistVariantId = String(data.variants[0].id);
          if (!data.variants[0].available) {
            var btn = card.querySelector('.wishlist-item__add-btn');
            if (btn) { btn.textContent = 'Sold Out'; btn.disabled = true; }
          }
        }
      })
      .catch(function () {});
  }

  function initWishlistPage() {
    var grid       = document.getElementById('wishlist-items-grid');
    var emptyEl    = document.getElementById('wishlist-empty-state');
    var emailStrip = document.getElementById('wishlist-email-strip');
    if (!grid) return;

    var items = Object.values(WishlistManager.getAll());

    if (items.length === 0) {
      if (emptyEl) emptyEl.style.display = 'block';
      if (emailStrip) emailStrip.style.display = 'none';
      grid.style.display = 'none';
      return;
    }

    if (emptyEl) emptyEl.style.display = 'none';
    grid.style.display = 'flex';
    grid.dataset.single = items.length === 1 ? 'true' : 'false';

    items.forEach(function (product) {
      var card = buildCard(product);
      grid.appendChild(card);
      if (product.handle) refreshCard(card, product.handle);
    });

    // Remove
    grid.addEventListener('click', function (e) {
      var removeBtn = e.target.closest('[data-wishlist-remove]');
      if (!removeBtn) return;
      var id = removeBtn.dataset.wishlistRemove;
      WishlistManager.remove(id);
      var card = document.getElementById('wishlist-item-' + id);
      if (card) {
        card.style.transition = 'opacity .25s, transform .25s';
        card.style.opacity = '0';
        card.style.transform = 'scale(0.97)';
        setTimeout(function () {
          if (card.parentNode) card.parentNode.removeChild(card);
          var remaining = Object.keys(WishlistManager.getAll()).length;
          if (remaining === 0) {
            if (emptyEl) emptyEl.style.display = 'block';
            if (emailStrip) emailStrip.style.display = 'none';
            grid.style.display = 'none';
          } else {
            grid.dataset.single = remaining === 1 ? 'true' : 'false';
          }
        }, 270);
      }
    });

    // Add to Cart
    grid.addEventListener('click', function (e) {
      var addBtn = e.target.closest('.wishlist-item__add-btn');
      if (!addBtn || addBtn.disabled) return;

      var card = addBtn.closest('[data-wishlist-product-id]');
      if (!card) return;

      var sel = card.querySelector('.wishlist-item__variant-select');
      var variantId = (sel && sel.value) ? sel.value : card.dataset.wishlistVariantId;
      if (!variantId) return;

      addBtn.textContent = 'Adding…';
      addBtn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: Number(variantId), quantity: 1 })
      })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status === 422) throw new Error(data.description || 'Item unavailable');
        return fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
      })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var ev = new Event('cart:update', { bubbles: true });
        ev.detail = { resource: cart, data: { source: 'wishlist', itemCount: cart.item_count } };
        document.dispatchEvent(ev);
        addBtn.textContent = 'Added!';
        setTimeout(function () { addBtn.textContent = 'Add to Cart'; addBtn.disabled = false; }, 2200);
      })
      .catch(function (err) {
        addBtn.textContent = 'Add to Cart';
        addBtn.disabled = false;
        alert(err.message || 'Could not add to cart. Please try again.');
      });
    });

    // Email strip — show when items exist and email not yet captured
    if (emailStrip && !localStorage.getItem(EMAIL_KEY)) {
      emailStrip.style.display = 'block';
      var stripForm = emailStrip.querySelector('#wishlist-page-email-form');
      if (stripForm) {
        stripForm.addEventListener('submit', function (e) {
          e.preventDefault();
          var emailInput = this.querySelector('input[type="email"]');
          var email = emailInput ? emailInput.value.trim() : '';
          if (!email) return;
          localStorage.setItem(EMAIL_KEY, email);
          klaviyoIdentify(email);
          if (items[0]) klaviyoTrackWishlist(items[0]);
          emailStrip.innerHTML = '<p class="page-wishlist__email-success">Wishlist saved to ' + escapeHtml(email) + '</p>';
        });
      }
    }
  }

  // ─────────────────────────────────────────────
  // Product detail page — floating heart on image
  // ─────────────────────────────────────────────
  var HEART_PATH = 'M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z';

  function initProductPageWishlist() {
    var dataEl = document.querySelector('[data-wishlist-product]');
    if (!dataEl || dataEl.dataset.wishlistInit) return;
    dataEl.dataset.wishlistInit = '1';

    var id = dataEl.dataset.wishlistId;
    if (!id) return;

    var product = {
      id:                  id,
      handle:              dataEl.dataset.wishlistHandle  || '',
      title:               dataEl.dataset.wishlistTitle   || '',
      priceCents:          dataEl.dataset.wishlistPrice   || '0',
      image:               dataEl.dataset.wishlistImage   || '',
      variantId:           dataEl.dataset.wishlistVariantId || '',
      hasMultipleVariants: dataEl.dataset.wishlistMultiVariants === 'true'
    };

    // Inject base heart CSS first, then PDP overrides — order matters for cascade
    injectStyles(HEART_CSS, 'wishlist-heart-css');
    injectStyles(PDP_EXTRA_CSS, 'wishlist-pdp-extra-css');

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'wishlist-heart wishlist-heart--pdp' + (WishlistManager.has(id) ? ' is-wishlisted' : '');
    btn.setAttribute('aria-label', WishlistManager.has(id) ? 'Remove from wishlist' : 'Add to wishlist');
    btn.innerHTML = HEART_SVG;

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      // Capture currently selected variant
      var activeVariant = document.querySelector('[name="id"]');
      if (activeVariant && activeVariant.value) product.variantId = activeVariant.value;

      var added = WishlistManager.toggle(product);
      btn.classList.toggle('is-wishlisted', added);
      btn.setAttribute('aria-label', added ? 'Remove from wishlist' : 'Add to wishlist');

      if (added) {
        klaviyoTrackWishlist(product);
        showEmailModal(product);
      }
    });

    // Mount on the media-gallery custom element (wraps all product images)
    var mediaWrapper = document.querySelector('media-gallery, .product-media-container, .product-media-wrapper, .product__media-wrapper');
    if (mediaWrapper) {
      mediaWrapper.style.position = 'relative';
      mediaWrapper.appendChild(btn);
    } else {
      var details = document.querySelector('.product-details, .product__info-wrapper');
      if (details) details.prepend(btn);
    }

    // Sync variant when customer switches variant
    window.addEventListener('variant:update', function (e) {
      var v = e && e.detail && e.detail.resource;
      if (v && v.id) product.variantId = String(v.id);
    });
  }

  // Double-class selector beats .wishlist-heart (0,1,0) with specificity (0,2,0)
  // so it wins regardless of which style tag is injected first.
  var PDP_EXTRA_CSS = '.wishlist-heart.wishlist-heart--pdp{top:auto;bottom:14px;right:14px;width:38px;height:38px;}';

  // ─────────────────────────────────────────────
  // Boot
  // ─────────────────────────────────────────────
  function init() {
    initHearts();
    updateBadges();
    initWishlistPage();
    initProductPageWishlist();
    cardObserver.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.WishlistManager = WishlistManager;
})();
